import { lazy } from "react";
import SetupTabsObj from "../../MainTabs/Setup/SetupTabsObj";
import ChargesTabsObj from "../../MainTabs/Charges/ChargesTabsObj";
import ReportsTabsObj from "../../MainTabs/Reports/ReportsTabsObj";
import SubmissionTabsObj from "../../MainTabs/Submissions/SubmissionTabsObj";

const Dashboard = lazy(
  () =>
    import(
      /* webpackChunkName: "Dashboard" */ "../../MainTabs/Dashboard/Dashboard"
    ),
);
const Patients = lazy(
  () =>
    import(
      /* webpackChunkName: "Patient" */ "../../MainTabs/Patients/Patients"
    ),
);
const Setup = lazy(
  () => import(/* webpackChunkName: "Setup" */ "../../MainTabs/Setup/Setup"),
);
const Submissions = lazy(
  () =>
    import(
      /* webpackChunkName: "Submission" */ "../../MainTabs/Submissions/Submissions"
    ),
);
const Reports = lazy(
  () =>
    import(
      /* webpackChunkName: "Reporting" */ "../../MainTabs/Reports/Reports"
    ),
);
const NewReports = lazy(
  () =>
    import(
      /* webpackChunkName: "NewReports" */ "../../MainTabs/NewReports/NewReports"
    ),
);
const Charges = lazy(
  () =>
    import(/* webpackChunkName: "Charges" */ "../../MainTabs/Charges/Charges"),
);
const InsurancePayments = lazy(
  () =>
    import(
      /* webpackChunkName: "InsurancePayments" */ "../../MainTabs/InsurancePayments/InsurancePayments"
    ),
);
const PatientPayments = lazy(
  () =>
    import(
      /* webpackChunkName: "PatientPayments" */ "../../MainTabs/PatientPayments/PatientPayments"
    ),
);
const PatientStatements = lazy(
  () =>
    import(
      /* webpackChunkName: "PatientStatements" */ "../../MainTabs/PatientStatements/PatientStatements"
    ),
);

const Denial = lazy(
  () => import(/* webpackChunkName: "Denial" */ "../../MainTabs/Denial/Denial"),
);

const Eligibility = lazy(
  () =>
    import(
      /* webpackChunkName: "Eligibility" */ "../../MainTabs/Eligibility/Eligibility"
    ),
);

const Tasks = lazy(
  () => import(/* webpackChunkName: "Tasks" */ "../../MainTabs/Tasks/Tasks"),
);
const ImportTab = lazy(
  () =>
    import(
      /* webpackChunkName: "Tasks" */ "../../MainTabs/ImportTab/ImportTab"
    ),
);
const EOBParser = lazy(
  () =>
    import(
      /* webpackChunkName: "EOBParser" */ "../../MainTabs/EOBParser/EOBParser"
    ),
);
const IntakeOnboarding = lazy(
  () => import(/* webpackChunkName: "IntakeAdmin" */ "../../IntakeAdmin/IntakeOnboardingApp"),
);
const IntakeScheduling = lazy(
  () => import(/* webpackChunkName: "IntakeAdmin" */ "../../IntakeAdmin/IntakeSchedulingApp"),
);
const IntakeAdmin = lazy(
  () => import(/* webpackChunkName: "IntakeAdmin" */ "../../IntakeAdmin/IntakeAdminApp"),
);

const Settings2 = lazy(
  () =>
    import(
      /* webpackChunkName: "Settings2" */ "../../MainTabs/Settings2/Settings2"
    ),
);
export const MainTabsComponent = {
  Dashboard,
  Patients,
  Setup,
  Submissions,
  Denial,
  Reports,
  NewReports,
  Charges,
  ImportTab,
  InsurancePayments,
  EOBParser,
  PatientPayments,
  PatientStatements,
  Eligibility,
  Tasks,
  IntakeOnboarding,
  IntakeScheduling,
  Settings2,
};
const MainTabsObj = () => {
  return [
    {
      title: "Dashboard",
      Component: "Dashboard",
      icon: "grid",
      eventKey: 68, // press d from keyboard
      data: {},
    },
    {
      title: "Patients",
      Component: "Patients",
      icon: "users",
      eventKey: 68, // press d from keyboard
      data: {},
    },

    // {
    //   title: "Billing",
    //   Component: "Billing",
    //   icon: FaFileMedical,

    //   eventKey: 68,
    //   subTabs: BillingTabsObj(), // press d from keyboard
    // },
    {
      title: "Charges",
      Component: "Charges",
      icon: "file",
      subTabs: ChargesTabsObj(),
      eventKey: 68, // press d from keyboard
      data: {},
    },

    {
      title: "Submissions",
      Component: "Submissions",
      subTabs: SubmissionTabsObj(),
      icon: "activity",
      eventKey: 68, // press d from keyboard
      data: {},
    },
    // {
    //   title: "Denial",
    //   Component: "Denial",
    //   icon: "/img/denial.svg",

    //   eventKey: 68,
    //   data: {},
    // },

    {
      title: "Insurance Payments",
      Component: "InsurancePayments",
      icon: "credit-card",
      eventKey: 68, // press d from keyboard
      data: {
        pID: 0,
        InsData: {
          paymenttype: "ERA_EOB",
          payerid: "",
          payerName: "",
          checknumber: "",
          checkdatefrom: "",
          checkdateto: "",
          depositdatefrom: "",
          depositdateto: "",
          poststatus: "All",
          entrydatefrom: "",
          entrydateto: "",
          receiveddatefrom: "",
          receiveddateto: "",
          visitid: "",
          posteddatefrom: "",
          posteddateto: "",
          dateType: "Check Date",
        },
        rowData: null,
      },
    },
    {
      title: "EOB Parser",
      name: "eobParser",
      Component: "EOBParser",
      // subTabs: SubmissionTabsObj(),
      icon: "eob-parser",
      eventKey: 68, // press d from keyboard
      data: null,
    },
    {
      title: "Patient Payments",
      Component: "PatientPayments",
      icon: "wallet",
      eventKey: 68, // press d from keyboard
      data: null,
    },
    {
      title: "Patient Statements",
      name: "patientStatements",
      Component: "PatientStatements",
      icon: "mail",
      eventKey: 68,
      data: {},
    },
    ...(process.env.REACT_APP_DEVELOPMENT
      ? [
        {
          title: "Scheduling",
          name: "patientIntake",
          Component: "IntakeScheduling",
          icon: "calendar",
          eventKey: 68,
          data: {},
        },
        {
          title: "Onboarding",
          name: "patientIntake",
          Component: "IntakeOnboarding",
          icon: "list",
          eventKey: 68,
          data: {},
        }
      ]
      : []),
    {
      title: "Data Import",
      name: "dataImport",
      Component: "ImportTab",
      icon: "upload",
      eventKey: 68,
      data: {},
    },
    {
      title: "Tasks",
      name: "tasks",
      Component: "Tasks",
      icon: "clock",
      eventKey: 68,
      data: {},
    },
    {
      title: "Eligibility",
      name: "eligibility",
      Component: "Eligibility",
      icon: "check-square",
      eventKey: 68,

      data: {},
    },

    {
      title: "Reports",
      Component: "Reports",
      icon: "bar-chart",
      eventKey: 68,
      subTabs: ReportsTabsObj(),
      data: {},
    },
    ...(process.env.REACT_APP_DEVELOPMENT
      ? [
        {
          title: "New Reports",
          name: "reports",
          Component: "NewReports",
          icon: "bar-chart",
          eventKey: 68,
          data: {},
        },
      ]
      : []),
    // {
    //   title: "Settings2",
    //   name: "settings2",
    //   Component: "Settings2",
    //   icon: "/img/Setting.svg",
    //   eventKey: 68,
    //   data: {},
    // },

    // {
    //   title: "New Reporting",
    //   Component: "NewReporting",
    //   icon: TbReportAnalytics,

    //   eventKey: 68,
    //   subTabs: NewReportingTabsObj(),
    // },
    // {
    //   title: "Scheduler",
    //   icon: MdAvTimer,

    //   eventKey: 68, // press d from keyboard
    // },
    {
      title: "Settings",
      name: "settings2",
      Component: "Settings2",
      icon: "settings",
      eventKey: 68,
      data: {},
    },
    // {
    //   title: "Settings",
    //   Component: "Setup",
    //   name: "setup",
    //   icon: "/img/Setting.svg",
    //   subTabs: SetupTabsObj(),
    //   eventKey: 68, // press d from keyboard
    //   data: {},
    // },
  ];
};

export default MainTabsObj;

